import { CartOrderManager } from 'cart-core';

/**
 * Waits for window.checkoutOrderManager to be instantiated else-ware then returns it.
 *
 * This also waits for the CheckoutOrderManager to actually have an order before resolving
 * in order to prevent duplicate simultaneous getCurrentOrder() calls which cause unnecessary
 * ajax calls and delays.
 *
 * @return Promise that resolves with {@link CheckoutOrderManager}
 */
export default function getCheckoutOrderManager() {
    return new Promise<CartOrderManager>((resolve, reject) => {
        const checkInterval = setInterval(() => {
                if (typeof window.checkoutOrderManager === 'object' && window.checkoutOrderManager.hasOrder()) {
                    clearInterval(checkInterval);
                    resolve(window.checkoutOrderManager);
                }
            },
            // Check every 5ms which causes about 200 total checks in testing on local, probably less on prod
            5
        );
    });
}
